import { Content, Arrows, StyledInput } from './number-input.styled';

export const NumberInput = (props) => {
  const def = {
    min: 0,
  };
  const propsOk = { ...def, ...props };
  const { value, onChange, min, max, disabled } = propsOk;

  /**
   * change from input
   * @param {*} event
   */
  const change = (event) => {
    const val = parseInt(event.target.value, 0);
    if (val <= max && val >= min) {
      onChange(val);
    }
  };

  /**
   * inc
   */
  const increaseValue = () => {
    if (!disabled && value < max) {
      onChange(value + 1);
    }
  };

  /**
   * dec
   */
  const decreaseValue = () => {
    if (!disabled && value > min) {
      onChange(value - 1);
    }
  };

  return (
    <Content>
      <StyledInput type="number" min={min} max={max} value={value} onChange={change} disabled={disabled} />
      <Arrows $disabled={disabled}>
        <svg onClick={increaseValue} viewBox="0 0 12 12" width="12" height="12" aria-label="up" role="button">
          <path d="M2 8L6 4L10 8" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <svg onClick={decreaseValue} viewBox="0 0 12 12" width="12" height="12" aria-label="down" role="button">
          <path d="M2 4L6 8L10 4" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Arrows>
    </Content>
  );
};
